import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs";

export const teachingVideoApi = createAsyncThunk(
    'auth/teachingVideos',
    async (data, { rejectWithValue }) => {
        try {
            const paramsData = new URLSearchParams(data);
            const response = await AuthAxios.get(apiRoutes.teachingVideosList, { params: data })
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)

const teachingVideoSlice = createSlice({
    name: 'teachingVideo',
    initialState: { result: [], loading: false, error: null, message: "", total: 0 },
    extraReducers: (builder) => {
        builder.addCase(teachingVideoApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(teachingVideoApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.message = action?.payload?.message
            state.total = action?.payload?.count
        })
        builder.addCase(teachingVideoApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})

export const teachingVideoReducer = teachingVideoSlice.reducer